import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  BaseApiTemplateService,
  Core2Config,
  ApiVisa,
  ApiResponseModel,
  Pagination,
  PagingResponseModel,
} from "../../shared";
import { BudgetRegisterContainerModel } from "../../../../../../models/aggregates/erp/financial/budget-register-container.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BudgetRegisterService extends BaseApiTemplateService<BudgetRegisterContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget/registers/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget/registers/backoffice-ep";
    this.httpClient = http;
  }

  createBudgetRegisters(
    dtoObject: any,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        Core2Config.FI_PREFIX +
        "budget/registers/custom/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getGroupedRegistersByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any
  ): Observable<PagingResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        Core2Config.FI_PREFIX +
        "budget/registers/group-all/backoffice-ep";
    }
    const UrlByCriteria = url + "/query?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}
